import React, { useEffect, useRef, FC } from 'react'
import classNames from 'classnames'

import SALink from 'components/SALink'

import { isActiveHref, QUICK_LINKS } from '../helpers/constants'
import { handleStudioLinkClick } from '../helpers/navigate'
import { scrollIntoViewWhenReady } from '../helpers/scrollIntoViewWhenReady'
import styles from './MobileQuickLinks.module.scss'

type MobileQuickLinksProps = {
  activeHref?: string
}

const MobileQuickLinks: FC<MobileQuickLinksProps> = ({ activeHref }) => {
  const containerRef = useRef<HTMLElement>(null)
  const quickLinks = QUICK_LINKS

  useEffect(() => {
    const activeLink = containerRef.current?.querySelector<HTMLElement>(`.${styles.linkActive}`)
    return scrollIntoViewWhenReady(activeLink ?? null, { block: 'nearest', inline: 'center' })
  }, [activeHref])

  return (
    <nav ref={containerRef} className={styles.quickLinks} aria-label='Quick access'>
      {quickLinks.map((link) => {
        const isActive = Boolean(activeHref && isActiveHref(activeHref, link.href))
        return (
          <SALink
            key={link.label}
            href={link.href}
            className={classNames(styles.link, { [styles.linkActive]: isActive })}
            target={link.openInNewTab ? '_blank' : ''}
            rel={link.openInNewTab ? 'noopener noreferrer' : ''}
            onClick={(event: React.MouseEvent<HTMLAnchorElement>) =>
              handleStudioLinkClick(event, link)
            }
          >
            {link.label}
          </SALink>
        )
      })}
    </nav>
  )
}

export default MobileQuickLinks
